const mediaItems = [
  {
    title: '本周必看推荐',
    desc: '编辑精选优质漫画，每周更新不容错过',
    icon: 'ri-star-line',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20manga%20illustration%20with%20warm%20lighting%2C%20action%20adventure%20comic%20scene%2C%20dynamic%20character%20posing%20with%20sword%2C%20soft%20orange%20and%20coral%20tones%2C%20clean%20artistic%20composition%2C%20anime%20style%20digital%20art%2C%20dramatic%20lighting%20from%20above%2C%20professional%20illustration%20quality&width=800&height=500&seq=media-card-01&orientation=landscape',
  },
  {
    title: '新番速递',
    desc: '第一时间追更最新连载，快人一步',
    icon: 'ri-flashlight-line',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20manga%20style%20illustration%20of%20two%20characters%20under%20cherry%20blossoms%2C%20soft%20pink%20and%20warm%20beige%20tones%2C%20gentle%20spring%20atmosphere%2C%20anime%20art%20style%2C%20dreamy%20lighting%20with%20bokeh%20effects%2C%20emotional%20storytelling%20vibe%2C%20clean%20composition&width=800&height=500&seq=media-card-02&orientation=landscape',
  },
  {
    title: '完结神作',
    desc: '一口气读完的经典完结漫画合集',
    icon: 'ri-check-double-line',
    image: 'https://readdy.ai/api/search-image?query=Fantasy%20manga%20illustration%20with%20magical%20elements%2C%20floating%20crystals%20and%20spell%20effects%2C%20mystical%20atmosphere%2C%20purple%20and%20gold%20color%20scheme%2C%20anime%20art%20style%2C%20ethereal%20lighting%2C%20enchanting%20otherworldly%20scene%2C%20clean%20and%20polished%20composition&width=800&height=500&seq=media-card-03&orientation=landscape',
  },
  {
    title: '独家首发',
    desc: '漫蛙独家引进，只在漫蛙才能看到',
    icon: 'ri-vip-crown-line',
    image: 'https://readdy.ai/api/search-image?query=Modern%20urban%20manga%20illustration%20with%20cityscape%20background%2C%20stylish%20characters%20in%20contemporary%20clothing%2C%20warm%20evening%20lighting%2C%20orange%20and%20teal%20color%20scheme%2C%20anime%20art%20style%2C%20cinematic%20composition%2C%20professional%20illustration%20with%20soft%20glow&width=800&height=500&seq=media-card-04&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-50 scroll-mt-header">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">精选专题</h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">编辑团队为你精心整理的漫画专题，发现更多好作品</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {mediaItems.map((item) => (
            <div
              key={item.title}
              className="group relative rounded-xl overflow-hidden bg-background-100 border border-background-200/70 cursor-pointer transition-all duration-300 hover:-translate-y-1"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent"></div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <div className="flex items-center gap-2 mb-1">
                  <div className="w-7 h-7 rounded-lg bg-primary-500/90 flex items-center justify-center">
                    <i className={`${item.icon} text-background-50 text-xs`}></i>
                  </div>
                  <h3 className="font-heading text-base font-bold text-white">{item.title}</h3>
                </div>
                <p className="text-white/80 text-xs">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}